module.exports = __webpack_public_path__ + "img/favicon.39eceff.png";